import * as types from './types'
// 保存筛选页面筛选数据
export const setDepositOrderFilterData = ({ commit }, data) => {
  commit(types.SET_DEPOSIT_ORDER_FILTER_DATA, data)
}
